import { useState } from "react";
import { Link } from "react-router-dom";
import {
  IconArrowBack,
  IconCalendar,
  IconCreditCard,
  IconUser,
  IconSettings,
  IconUsers,
  IconChartBar,
  IconClock,
  IconChevronDown,
  IconChevronUp,
  IconBrandProducthunt
} from "@tabler/icons-react";

const DashboardLink = ({ role }) => {
  const [storeSettingsOpen, setStoreSettingsOpen] = useState(false);

  const toggleStoreSettings = () => {
    setStoreSettingsOpen(!storeSettingsOpen);
  };

  const userLinks = (
    <>
      <Link
        to="/dashboard"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconCalendar
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Dashboard
      </Link>
      <Link
        to="/dashboard/payments"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconCreditCard
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Payment History
      </Link>
      <Link
        to="/dashboard/profile"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconUser
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Profile
      </Link>
    </>
  );

  const clientLinks = (
    <>
      <Link
        to="/dashboard/client-orders"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconCreditCard
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Orders
      </Link>
      <Link
        to="/dashboard/products"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
      >
        <IconBrandProducthunt
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Products
      </Link>
    </>
  );

  const adminLinks = (
    <>
      <Link
        to="/dashboard/admin"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconChartBar
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Admin Panel
      </Link>
      <Link
        to="/dashboard/client-orders"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconCreditCard
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Orders
      </Link>
      <Link
        to="/dashboard/products"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
      >
        <IconBrandProducthunt
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Products
      </Link>
      <Link
        to="/dashboard/manage-users"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconUsers
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        User Management
      </Link>
      <Link
        to="/dashboard/reports"
        className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
      >
        <IconChartBar
          className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
          aria-hidden="true"
        />
        Reports
      </Link>
    </>
  );

  return (
    <>
      {role === "user" && userLinks}
      {role === "client" && clientLinks}
      {role === "admin" && adminLinks}
      <div className="md:hidden">
        <Link
          to="/"
          className="text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
        >
          <IconArrowBack
            className="mr-4 flex-shrink-0 h-6 w-6 text-gray-400 group-hover:text-gray-500"
            aria-hidden="true"
          />
          Back
        </Link>
      </div>
    </>
  );
};

export default DashboardLink;
